"use client";
import { useState } from "react";
import Image from "next/image";
import DEFAULT_IMG from "@/img/blog/img-default.png";

interface ImageWithLoaderProps {
  className?: string;
  src: any;
  alt: string;
  width?: number;
  height?: number;
  sizes?: string;
  style?: object;
  showLoader?: boolean;
  priority?: boolean;
  quality?: any;
  title?: string;
  caption?: string;
  fill?: boolean
}

export const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({
  src,
  alt,
  width,
  height,
  showLoader,
  caption,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(
    showLoader == false ? false : true
  );
  const [imageLoadError, setImageLoadError] = useState<boolean>(false);

  const handleImageLoad = () => {
    setIsLoading(false);
  };
  const handleImageErrorLoad = () => {
    setImageLoadError(true);
  };

  return (
    <div className="image-wrapper">
      {isLoading && <div className="loading-indicator">Loading...</div>}
     
      <figure>
        <Image
          {...rest}
          src={imageLoadError ? DEFAULT_IMG : src}
          alt={alt}
          width={width}
          height={height}
          onLoad={handleImageLoad}
          onError={handleImageErrorLoad}
        />
        {caption && (
          <figcaption style={{ color: "#6B6B6B", textAlign: "center", fontSize: "13px"}}>
            {caption}
          </figcaption>
        )}
      </figure>
    </div>
  );
};
